const state = {
  selectBuildings: [], // 选中的楼盘信息
  selectAdvisor: undefined, // 选中的置业人员,
  backupInfo: {
    cusName: "",
    cusSex: "男",
    cusTel: "",
    remark: ""
  },
  agentAuth: {
    phone: "",
    code: "",
    auth: {
      name: "",
      status: false
    }
  },
  invitedAgentList: [], // 已发展经纪人列表
  agentId: "", //经纪人ID
  agentTel: "" //经纪人电话号码
};

const mutations = {
  changeState(state, { key, value }) {
    state[key] = value;
  },
  saveSelectBuildings(state, payload) {
    const needRest =
      payload.length > 1 ||
      (payload.length === 1 &&
        state.selectBuildings.length === 1 &&
        payload[0].id !== state.selectBuildings[0].id);
    state.selectBuildings = payload;
    if (needRest) {
      state.selectAdvisor = undefined;
    }
  },
  saveSelectAdvisor(state, payload) {
    state.selectAdvisor = payload;
  },
  saveBackupInfo(state, payload) {
    state.backupInfo = { ...state.backupInfo, ...payload };
  },
  saveAgentAuth(state, payload) {
    state.agentAuth = { ...state.agentAuth, ...payload };
  },
  saveInvitedAgentList(state, payload) {
    state.invitedAgentList = payload;
  },
  saveAgentId(state, payload) {
    state.agentId = payload;
  },
  saveAgentTel(state, payload) {
    state.agentTel = payload;
  },
  reset(state, payload) {
    state.selectBuildings = [];
    state.selectAdvisor = undefined;
    state.backupInfo = {
      cusName: "",
      cusSex: "男",
      cusTel: "",
      remark: ""
    };
  }
};

const actions = {};
export default { namespaced: true, state, mutations, actions };
